export default "__VITE_ASSET__fp4G4CI1__"